import { jsx as _jsx } from "react/jsx-runtime";
import { SpecraButton } from '@mono/ui-components';
import { Testids } from '@mono/ui-selectors';
import { useNavigate } from 'react-router-dom';
import { GrowthWorkspaceListPage } from './GrowthWorkspaceListPage';
/** GRW-02: `/growth/rfi-responses`. "New RFI response" opens WRT's create form. */ export function RfiResponsesListPage() {
    const navigate = useNavigate();
    return /*#__PURE__*/ _jsx(GrowthWorkspaceListPage, {
        kind: "rfi_response",
        actions: /*#__PURE__*/ _jsx(SpecraButton, {
            "data-testid": Testids.growthWorkspaces.newRfiButton,
            onClick: ()=>navigate('/rfi-response/new'),
            children: "New RFI response"
        })
    });
}
